import { type MetaFunction } from '@remix-run/node'
import programNonprofits from './program-nonprofits.png'

export const meta: MetaFunction = () => [
	{ title: 'Insurance for Nonprofits' },
	{
		name: 'description',
		content: 'We offer insurance for nonprofits.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Nonprofit Insurance</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Looking to insure your nonprofit? Small or large, we have a program for
				you. Your nonprofit has special needs. You deserve special coverage,
				too. Call today!
			</p>
			<img
				src={programNonprofits}
				alt="Volunteers working together to move boxes of food."
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Nonprofit organizations play a crucial role in addressing social,
				environmental, and community-based challenges, relying heavily on
				limited resources and often operating with a strong sense of purpose. In
				light of their unique nature, nonprofits have specific insurance needs
				that require thoughtful consideration. Firstly, general liability
				insurance is a fundamental requirement for nonprofits, as it provides
				coverage for bodily injury, property damage, and personal injury claims
				that may arise from their operations. Given the nature of their work,
				which often involves events, volunteer activities, and community
				engagement, nonprofits need protection against potential lawsuits and
				claims that could drain their financial resources and compromise their
				mission.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Nonprofits also require coverage for directors and officers (D&O)
				liability insurance. The decisions made by the board members and leaders
				of nonprofit organizations can be subject to legal scrutiny, and D&O
				insurance provides protection in case allegations of mismanagement,
				financial impropriety, or breach of duty arise. This coverage not only
				safeguards the personal assets of the individuals in leadership
				positions but also helps to attract qualified directors and officers, as
				they can feel more confident in their decision-making roles knowing they
				have this protection.
			</p>
		</main>
	)
}
